import * as yup from 'yup'

export const verifyOTPFormSchema = yup.object().shape({
  code: yup.string().required('Code is required'),
})

export type VerifyOTPFormSchema = yup.InferType<typeof verifyOTPFormSchema>
